import React, { useState } from "react";
import { CloseIcon, SwapGrayIcon, SwapIcon } from "../../../../assets/images";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { RadioContainer } from "../../../../components/commons";
import { RadioTypes } from "../../../../commonTypes/universalTypes";

const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "Recently Added First",
    name: "Recently Added First",
  },
  {
    id: "Job Type - A to Z",
    name: "Job Type - A to Z",
  },
  {
    id: "Job Type - Z to A",
    name: "Job Type - Z to A",
  },
];

const USER_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "Recently Added First",
    name: "Recently Added First",
  },
  {
    id: "User - A to Z",
    name: "User - A to Z",
  },
  {
    id: "User - Z to A",
    name: "User - Z to A",
  },
];




type sortByJobType = {
  name: string;
  value: string;
};

type AppProps = {
  sortByJobType: sortByJobType;
  setSortByUserType:React.Dispatch<React.SetStateAction<sortByJobType>>;
  sortByUserType:sortByJobType;
  setSortByJobType: React.Dispatch<React.SetStateAction<sortByJobType>>;
  sortByTargetEndDate: sortByJobType;
  setSortByTargetEndDate: React.Dispatch<React.SetStateAction<sortByJobType>>;
  jobStatus: sortByJobType;
  setJobStatus: React.Dispatch<React.SetStateAction<sortByJobType>>;
  recentlyAdded: sortByJobType;
  type?:string;
  setRecentlyAdded: React.Dispatch<React.SetStateAction<sortByJobType>>;
};

const ClientJobScheduleSorting = ({
  sortByJobType,
  setSortByJobType,
  sortByTargetEndDate,
  setSortByUserType,
  sortByUserType,
  setSortByTargetEndDate,
  jobStatus,
  setJobStatus,
  recentlyAdded,
  setRecentlyAdded,
  type
}: AppProps) => {
  const [toggle, setToggle] = useState<boolean>(false);
  const setAllStatesEmpty = () => {
    setRecentlyAdded({
      name: "",
      value: "",
    });
    setSortByJobType({
      name: "",
      value: "",
    });
    setSortByTargetEndDate({
      name: "",
      value: "",
    });
    setSortByUserType({
      name: "",
      value: ""
    })

  };

  

  const handleRadioValue = (data: string) => {
    const emptyState = {
      name: "",
      value: "",
    };
  
    switch (data) {
      case "Recently Added First":
        setRecentlyAdded({
          name: "Recently Added First",
          value: "",
        });
        break;
      case "Job Type - A to Z":
        setSortByJobType({
          name: "Job Type - A to Z",
          value: "asc",
        });
        break;
      case "Job Type - Z to A":
        setSortByJobType({
          name: "Job Type - Z to A",
          value: "desc",
        });
        break;
      case "User - A to Z":
        setSortByUserType({
          name:"User - A to Z",
          value:"asc"
        })
        break;
      case "User - Z to A":
        setSortByUserType({
          name:"User - Z to A",
          value:"desc"
        })
        break;
      default:
        setAllStatesEmpty();
        return;
    }
  
    switch (data) {
      case "Recently Added First":
        setSortByJobType(emptyState);
        setSortByUserType(emptyState)
        break;
      case "Job Type - A to Z":
      case "Job Type - Z to A":
      case "User - A to Z":
      case "User - Z to A":
        setRecentlyAdded(emptyState);
        break;
    }
  };
  

  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        setToggle(!toggle);
      }}
    >
      <OverlayTrigger
        placement="bottom"
        delay={{ show: 250, hide: 250 }}
        overlay={<Tooltip id="button-view-download-invoice">Sorting</Tooltip>}
      >
        <DropdownToggle
          caret
          color="secondary"
          style={{ border: "1px solid#bfcbe1" }}
          outline
          toggle={() => {
            setToggle(!toggle);
          }}
        >
          <img src={((!!type && type==="JobSpecificUsersReport") ? sortByUserType?.value  : (sortByJobType?.value || sortByTargetEndDate?.value ||jobStatus?.value))? SwapIcon : SwapGrayIcon} alt="" />
        </DropdownToggle>
      </OverlayTrigger>
      <DropdownMenu right style={{ width: "340px", padding: "15px 15px 15px" }}>
        <div className="d-flex justify-content-between mt-0 mb-0">
          <h5 className="text-center ">Sort</h5>
          <div
            className="pointer"
            onClick={() => {
              setToggle(!toggle);
            }}
          >
            <img src={CloseIcon} alt="" />
          </div>
        </div>
        <hr className="mt-0 mb-0" />
        <div className="row d-block p-3">
          <div>
            <RadioContainer
              optionsList={ type==="JobSpecificUsersReport" ? USER_RADIO_OPTIONS :RADIO_OPTIONS}
              handleSetRadioValue={handleRadioValue}
              radioValue={
                type==="JobSpecificUsersReport" ? (sortByUserType?.name
                  ? sortByUserType?.name
                  : "Recently Added First"):(sortByJobType?.name
                  ? sortByJobType?.name
                  : "Recently Added First")
              }
              alignment="vertical"
              backGround={true}
            />
          </div>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default ClientJobScheduleSorting;
